import { useEffect } from 'react';
import { requestPersistentStorage } from '../lib/pwa';

/**
 * Запрашивает navigator.storage.persist() при старте приложения,
 * чтобы Safari/iOS реже чистил IndexedDB неиспользуемых сайтов.
 */
export function PwaInstallToast() {
  useEffect(() => {
    void requestPersistentStorage();
  }, []);

  return null;
}
